import { useContext } from 'react'
import { SubscriptionContext } from '../providers/SubscriptionProvider'

export function useSubscription() {
  return useContext(SubscriptionContext)
}
